import React from 'react';
import PropTypes from 'prop-types';
import GarageViewTabContent from 'commons-garage/components/Garage/GarageViewTabContent.jsx';
import { Quote, Vehicle } from '@sm360/widget-commons-vehicle';

import 'commons-garage/components/Garage/Garage.scss';

const GarageView = ({
    dataTest,
    isNewEnabled,
    isUsedEnabled,
    usedUrl,
    timeSaved,
    tradeInAmount,
    isReservationMode,
    tradeInTaxCredits,
    deleteQuote,
    quotes,
    forceVehiclesFetch,
    tradeInVehicle,
    isMultiDealerGarage,
    hasAdobeTagging,
    displayCreditRate,
}) => {
    // official evaluation value expiry date
    const officialAmountExp =
        Date.parse(
            tradeInVehicle?.evaluatorValues?.expirationDate ||
                tradeInVehicle?.tradeInExtraInfo?.evaluatorValues?.expirationDate
        ) || 0;
    const isOfficialAmountExpired = !!officialAmountExp && new Date(officialAmountExp) <= new Date();

    return (
        <div className="widget-garage" data-test={dataTest}>
            <div className="GarageView sr-garage">
                <div className="GarageView-button-opening">
                    <GarageViewTabContent
                        isNewEnabled={isNewEnabled}
                        isUsedEnabled={isUsedEnabled}
                        usedUrl={usedUrl}
                        timeSaved={timeSaved}
                        tradeInAmount={tradeInAmount}
                        isReservationMode={isReservationMode}
                        tradeInTaxCredits={tradeInTaxCredits}
                        deleteQuote={deleteQuote}
                        quotes={quotes}
                        forceVehiclesFetch={forceVehiclesFetch}
                        isOfficialAmountExpired={!!isOfficialAmountExpired}
                        isMultiDealerGarage={!!isMultiDealerGarage}
                        hasAdobeTagging={hasAdobeTagging}
                        displayCreditRate={displayCreditRate}
                        displayTradeInCreditRate // Set to false to hide TradeIn tax credit
                    />
                </div>
            </div>
        </div>
    );
};

GarageView.defaultProps = {
    isReservationMode: false,
    quotes: [],
    tradeInVehicle: new Vehicle.TradeInVehicleModel(),
    hasAdobeTagging: false,
    displayCreditRate: false,
};

GarageView.propTypes = {
    dataTest: PropTypes.string.isRequired,
    isNewEnabled: PropTypes.bool.isRequired,
    isUsedEnabled: PropTypes.bool.isRequired,
    usedUrl: PropTypes.string.isRequired,
    tradeInAmount: PropTypes.number.isRequired,
    timeSaved: PropTypes.number,
    isReservationMode: PropTypes.bool,
    tradeInTaxCredits: PropTypes.number.isRequired,
    deleteQuote: PropTypes.func.isRequired,
    quotes: PropTypes.arrayOf(PropTypes.instanceOf(Quote.QuoteModelV25)),
    forceVehiclesFetch: PropTypes.bool.isRequired,
    tradeInVehicle: PropTypes.instanceOf(Vehicle.TradeInVehicleModel),
    isMultiDealerGarage: PropTypes.bool.isRequired,
    hasAdobeTagging: PropTypes.bool,
    displayCreditRate: PropTypes.bool,
};

GarageView.displayName = 'GarageView';

export default GarageView;
